import type { LinkElement } from '../internal';
import { createDefaultText } from '../internal';

export function createDefaultLink(href: string): LinkElement {
  return {
    children: [createDefaultText()],
    href,
    suggestedEdits: [],
    type: 'link',
  };
}

export function createLinkWithChildren(
  href: string,
  children: LinkElement['children']
): LinkElement {
  return {
    children,
    href,
    suggestedEdits: [],
    type: 'link',
  };
}
